var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from "react";
import { NotificationService } from "./NotificationService";
import { CheckCircleIcon, ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Transition } from "@headlessui/react";
var NotificationContainer = /** @class */ (function (_super) {
    __extends(NotificationContainer, _super);
    function NotificationContainer(props) {
        var _this = _super.call(this, props) || this;
        NotificationService.subscribe(_this);
        _this.state = {
            messages: []
        };
        return _this;
    }
    ;
    NotificationContainer.prototype.notify = function (message) {
        var _this = this;
        message.show = false;
        message.id = "notification-".concat(new Date().getTime());
        var updatedMessages = __spreadArray(__spreadArray([], this.state.messages, true), [message], false);
        this.setState({ messages: updatedMessages }, function () {
            var newMessages = _this.state.messages.map(function (m) { return (__assign(__assign({}, m), { show: true })); });
            _this.setState({ messages: newMessages });
        });
    };
    ;
    NotificationContainer.prototype.render = function () {
        var _this = this;
        var triggerAutoHide = function (id, delay) {
            setTimeout(function () {
                var newMessages = _this.state.messages.map(function (m) { return m.id === id ? __assign(__assign({}, m), { show: false }) : m; });
                _this.setState({
                    messages: newMessages
                }, function () {
                    setTimeout(function () {
                        var messagesLeft = newMessages.filter(function (m) { return m.id !== id; });
                        _this.setState({ messages: messagesLeft });
                    }, 100);
                });
            }, delay);
        };
        return (_jsx("div", __assign({ "aria-live": "assertive", className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 md:items-start md:p-6 z-30" }, { children: _jsx("div", __assign({ className: "flex w-full flex-col items-center space-y-4 md:items-end z-30" }, { children: this.state.messages.map(function (notification) {
                    return (_jsx(Transition, __assign({ show: _this.state.messages.filter(function (m) { return m.id === notification.id; })[0].show, as: Fragment, enter: "transform ease-out duration-300 transition", enterFrom: "translate-y-2 opacity-0 md:translate-y-0 md:translate-x-2", enterTo: "translate-y-0 opacity-100 md:translate-x-0", leave: "transition ease-in duration-100", leaveFrom: "opacity-100", leaveTo: "opacity-0", afterEnter: function () { return triggerAutoHide(notification.id, 3000); } }, { children: _jsx("div", __assign({ id: notification.id, className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5" }, { children: _jsx("div", __assign({ className: "p-4" }, { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("div", __assign({ className: "flex-shrink-0" }, { children: notification.type === "success"
                                                ? _jsx(CheckCircleIcon, { className: "h-6 w-6 text-green-400", "aria-hidden": "true" })
                                                : _jsx(ExclamationTriangleIcon, { className: "h-6 w-6 text-red-400", "aria-hidden": "true" }) })), _jsx("p", __assign({ className: "w-0 flex-1 text-sm font-medium text-gray-900 ml-3" }, { children: notification.text })), _jsx("div", __assign({ className: "ml-4 flex flex-shrink-0" }, { children: _jsxs("button", __assign({ type: "button", className: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2", onClick: function (e) {
                                                    e.preventDefault();
                                                    triggerAutoHide(notification.id, 0);
                                                } }, { children: [_jsx("span", __assign({ className: "sr-only" }, { children: "Close" })), _jsx(XMarkIcon, { className: "h-5 w-5", "aria-hidden": "true" })] })) }))] })) })) })) }), notification.id));
                }) })) })));
    };
    ;
    return NotificationContainer;
}(React.Component));
export default NotificationContainer;
